import React from 'react';
import PageBackground from './PageBackground';
import './Layout.css';

export default function Layout({ round, title, subtitle, children }) {
  return (
    <div className="hunt-page">
      <PageBackground />

      <div className="hunt-content">
        {round && <div className="round-badge">{round}</div>}
        {title && (
          <h1 className="hunt-title hunt-title--with-icon">
            <span className="hunt-title__icon" aria-hidden="true">🪔</span>
            <span className="hunt-title__text">{title}</span>
            <span className="hunt-title__icon" aria-hidden="true">🪔</span>
          </h1>
        )}
        {subtitle && <p className="hunt-subtitle">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
